"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPropInitialValue = exports.expandShorthandCssProp = exports.getShorthandComputedProps = void 0;
var tslib_1 = require("tslib");
// Note: this file is generated automatically when running yarn (built by extract-mdn-data):
var css_shorthands_1 = require("./css-shorthands");
var general_utils_1 = require("../general-utils");
var shorthand_expand_utils_1 = require("./shorthand-expanders/shorthand-expand-utils");
var browser_compute_css_1 = require("./shorthand-expanders/browser-compute-css");
var shorthands_opener_1 = require("@wix/shorthands-opener");
var valueParser = require('postcss-value-parser');
var isString = function (str) { return typeof str === 'string'; };
function getPropertyMetadata(prop) {
    var match = Object.entries(css_shorthands_1.cssShorthandMap).find(function (entry) {
        return entry[0] === prop;
    });
    return match ? match[1] : undefined;
}
/*
given a shorthand prop name -
return a list of the matching longhand props (taken from mdn/data)
 */
function getShorthandComputedProps(prop) {
    var matchingEntry = getPropertyMetadata(prop);
    if (matchingEntry === undefined) {
        return [];
    }
    if (matchingEntry.computed === undefined || matchingEntry.computed.length === 0) {
        return [prop];
    }
    var levelOneComputed = matchingEntry.computed || [];
    var deeperProps = levelOneComputed.reduce(function (acc, longhandProp) {
        acc = acc.concat(getShorthandComputedProps(longhandProp));
        return acc;
    }, []);
    return (0, general_utils_1.removeDuplicates)(levelOneComputed.concat(deeperProps)); // TODO we don't really need to removeDuplicates if we don't insert them twice to begin with
}
exports.getShorthandComputedProps = getShorthandComputedProps;
/*
add resolved initial property where 'initial' keyword exists in parsed css
 */
function normalizeInitialsOnParsedCss(prop, parsedCss) {
    parsedCss.walk(function (node) {
        if (node.type === 'word') {
            if (node.value === 'initial') {
                node.value = getPropInitialValue(prop);
            }
        }
    });
}
/*
attach initial value to declaration map props if no value specified for longhand prop
 */
function attachInitials(declarationMap, computedProps) {
    var result = Object.assign({}, declarationMap);
    computedProps.forEach(function (longhand) {
        if (result[longhand] === undefined) {
            result[longhand] = getPropInitialValue(longhand);
        }
    });
    return result;
}
/*
resolve computed props from prop with value.
 */
function resolveComputedValues(prop, value, computedProps, includeInitialValues) {
    if (computedProps === void 0) { computedProps = []; }
    if (includeInitialValues === void 0) { includeInitialValues = false; }
    // try using propExpander to expand prop if
    var expanded = (0, shorthand_expand_utils_1.propExpander)(prop, value);
    if (expanded !== undefined) {
        if (includeInitialValues) {
            return attachInitials(expanded, computedProps);
        }
        else {
            return expanded;
        }
    }
    var hasSpxValue = /(-?[\d.]+)spx/.test(value);
    if (hasSpxValue) {
        // Use shorthands-opener library to parse value
        var openedShorthandLayers = (0, shorthands_opener_1.openShorthand)(prop, value);
        var declarationMap_1 = {};
        openedShorthandLayers.forEach(function (openedShorthand) {
            Object.entries(openedShorthand).forEach(function (_a) {
                var _b = tslib_1.__read(_a, 2), propKey = _b[0], propValue = _b[1];
                var previousLayersValue = declarationMap_1[propKey];
                var getValue = function (ast) {
                    return ast.value.text;
                };
                var currentLayerValue = Array.isArray(propValue)
                    ? propValue.map(getValue).join(' ')
                    : getValue(propValue);
                var mergedLayers = previousLayersValue
                    ? [previousLayersValue, currentLayerValue].join(', ')
                    : currentLayerValue;
                declarationMap_1[propKey] = mergedLayers;
            });
        });
        return declarationMap_1;
    }
    // if no implementation exists for given prop - expand using browserComputeCss
    var browserComputeCss = new browser_compute_css_1.BrowserComputeCss(prop, value);
    return computedProps.reduce(function (acc, longhandProp) {
        var propertyValue = browserComputeCss.getLonghand(longhandProp);
        var parsed = valueParser(propertyValue);
        if (includeInitialValues) {
            normalizeInitialsOnParsedCss(longhandProp, parsed);
        }
        else if (propertyValue === 'initial' ||
            (propertyValue === getPropInitialValue(longhandProp) && !value.includes(propertyValue))) {
            // if prop value is directly 'initial' or originated from 'initial' - don't include it
            return acc;
        }
        acc[longhandProp] = parsed.toString(); // Add longhand prop to accumulated map
        return acc;
    }, {});
}
/*
expands a css shorthand property to its longhand props
returns a declaration map with the matching longhand props extracted from value
 */
function expandShorthandCssProp(prop, value, includeInitialValues, disableBackground) {
    var _a;
    if (includeInitialValues === void 0) { includeInitialValues = false; }
    if (disableBackground === void 0) { disableBackground = false; }
    var computedProps = getShorthandComputedProps(prop);
    if (computedProps.length === 0) {
        throw new Error("expandShorthandProps, cannot expand prop '".concat(prop, "'"));
    }
    if (prop === 'background') {
        if (disableBackground) {
            // We throw an error for background props since background shorthands are fully opened by the background-driver
            throw new Error("expandShorthandProps disabled for background");
        }
        else {
            // Maintaining similar behaviour to css-property-parser: throwing error for multiple layer of background
            var ast = valueParser(value);
            if (ast.nodes &&
                ast.nodes.length > 1 &&
                ast.nodes.find(function (node) { return node.type === 'div' && node.value === ','; })) {
                throw new Error("expandShorthandProps disabled for background with more than one layer");
            }
        }
    }
    // if longhand - don't transpose it
    if (computedProps.length === 1 && computedProps[0] === prop) {
        return _a = {},
            _a[prop] = value,
            _a;
    }
    return resolveComputedValues(prop, value, computedProps, includeInitialValues);
}
exports.expandShorthandCssProp = expandShorthandCssProp;
/*
returns the initial value for a given prop, as specified in mdn/data
if prop is a shorthand and all matching initial values are the same - their value is returned
 */
function getPropInitialValue(prop) {
    var retVal;
    var matchingEntry = getPropertyMetadata(prop);
    if (matchingEntry === undefined || matchingEntry.initial === undefined) {
        return undefined;
    }
    var initial = matchingEntry.initial;
    if (isString(initial)) {
        retVal = initial;
    }
    else if (Array.isArray(initial)) {
        var sameValue_1 = true;
        var temp_1 = getPropInitialValue(initial[0]);
        initial.forEach(function (singleInitial) {
            if (getPropInitialValue(singleInitial) !== temp_1) {
                sameValue_1 = false;
            }
        });
        if (sameValue_1 && isString(temp_1)) {
            retVal = temp_1;
        }
    }
    return retVal;
}
exports.getPropInitialValue = getPropInitialValue;
//# sourceMappingURL=property-parser.js.map